import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SFDIntercepter } from './http-header-intercept';



/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: SFDIntercepter, multi: true },
];